import { CalendarBadge } from "PFComponents/badges_list/calendar_badge";
import SimpleBadge from "PFComponents/badges_list/simple_badge";
import { Typography } from "PFComponents/typography";
import PropTypes from "prop-types";
import React from "react";

import { ActionIcon } from "../action_icon";
import css from "./autoselect_values.module.scss";

const AutoSelectValues = ({
  values,
  locked,
  multi,
  disabled,
  suffixElement,
  onRemove,
  style,
  onDateChange,
  hasValuesWithExpiryDate,
  renderItem
}) => {
  const shownValues = (multi ? values : values.slice(0, 1)) || [];

  if (shownValues.length === 0) {
    return null;
  }

  return (
    <div
      className={css.multiValues}
      style={disabled ? { opacity: 0.5, pointerEvents: "none", ...style } : style}
    >
      {shownValues.map((val) => {
        let displayValue = val.displayElement || val.text || val.value || "";
        if (val.displayElement === 0 || val?.text === 0 || val?.value === 0) {
          displayValue = 0;
        }

        if (renderItem) {
          return renderItem({ key: val.id, value: val, onRemove: (e) => onRemove(val, e) });
        }
        return hasValuesWithExpiryDate ? (
          <CalendarBadge
            key={val.id}
            displayValue={displayValue}
            value={val}
            onRemove={onRemove}
            onDateChange={onDateChange}
            isLocked={locked}
          />
        ) : (
          <div key={val.id}>
            {multi ? (
              <SimpleBadge
                text={displayValue}
                kind={val.item?.kind}
                classes={{ root: css.badge }}
                icon={
                  !locked && !val.item.locked ? (
                    <ActionIcon name="cross" size="xs" onClick={(e) => onRemove(val, e)} />
                  ) : null
                }
              />
            ) : (
              <Typography variant={multi ? "bodyButtons" : "bodyRegular"} tag="span">
                {displayValue}
              </Typography>
            )}
            {suffixElement && <div className={suffixElement.className}>{suffixElement.text}</div>}
          </div>
        );
      })}
    </div>
  );
};

AutoSelectValues.propTypes = {
  onRemove: PropTypes.func.isRequired,
  onDateChange: PropTypes.func.isRequired,
  values: PropTypes.arrayOf(
    PropTypes.shape({ id: PropTypes.any, displayElement: PropTypes.any, item: PropTypes.any })
  ),

  style: PropTypes.object,
  hasValuesWithExpiryDate: PropTypes.bool,

  locked: PropTypes.bool,
  multi: PropTypes.bool,
  disabled: PropTypes.bool,
  suffixElement: PropTypes.shape({ className: PropTypes.string, text: PropTypes.node }),
  renderItem: PropTypes.func
};

export default AutoSelectValues;
